import React from 'react';
import './connection-editor.css';
import rest from '../connection-creator/rest.png';
import ex10 from '../connection-creator//e2010.png';
import exchange from '../connection-creator//exchange.png';
import htmlImg from '../connection-creator//html.png';
import soap from '../connection-creator//soap.png';
import sqlImg from '../connection-creator//sql.png';
import HttpConnector from '../connection-creator/http-connector/HttpConnector';
import SoapConnector from '../connection-creator/soap-connector/SoapConnector';
import HtmlConnector from '../connection-creator/html-connector/HtmlConnector';
import ExchangeConnector from '../connection-creator/exchange-connector/ExchangeConnector';
import ExchangeWSConnector from '../connection-creator/exchangewebservice-connector/ExchangeWebServiceConnector';
import SQLConnector from '../connection-creator/sql-connector/SqlConnector';
import ComponentHelper from '../../../supers/ComponentHelper';

class ConnectionEditor extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
	}

	defaultState = () => {
		return {
			connection: this.props.connection || {},
			testing: this.props.testing
		};
	};

	getTypeImage = type => {
		switch (type) {
			case 'http-connector': {
				return rest;
			}
			case 'soap-connector': {
				return soap;
			}
			case 'html-connector': {
				return htmlImg;
			}
			case 'ews-exchange-connector': {
				return exchange;
			}
			case 'exchange-connector': {
				return ex10;
			}
			case 'sql-connector': {
				return sqlImg;
			}
			default: {
				return '';
			}
		}
	};

	buildStepCard = () => {
		switch (this.data.connection.type) {
			case 'http-connector': {
				return <HttpConnector connection={this.data.connection} />;
			}
			case 'soap-connector': {
				return <SoapConnector connection={this.data.connection} />;
			}
			case 'html-connector': {
				return <HtmlConnector connection={this.data.connection} />;
			}
			case 'ews-exchange-connector': {
				return <ExchangeConnector connection={this.data.connection} />;
			}
			case 'exchange-connector': {
				return <ExchangeWSConnector connection={this.data.connection} />;
			}
			case 'sql-connector': {
				return <SQLConnector connection={this.data.connection} />;
			}
			default: {
				return '';
			}
		}
	};

	buildStepHeader = () => {
		switch (this.data.connection.type) {
			case 'http-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			case 'soap-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			case 'html-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			case 'ews-exchange-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			case 'exchange-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			case 'sql-connector': {
				return (
					<div className="editor-header">
						<img src={this.getTypeImage(this.data.connection.type)} alt="Connection Type" />
					</div>
				);
			}
			default: {
				return '';
			}
		}
	};

	render() {
		let { type } = this.data.connection;
		return (
			<div className="connection-editor-view animated fadeIn">
				<div className="main-content">
					{type && (
						<div className="editor-content">
							{this.buildStepHeader()}
							{this.buildStepCard()}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default ConnectionEditor;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-editor/ConnectionEditor.js